<div>
  <div class="buttons">
    <mat-form-field class="filter" [class.disabled]="!dataSrc.data.length || editandoLinha"
      [appDisableInteraction]="!dataSrc.data.length || editandoLinha">
      <input matInput type="text" placeholder="Filtrar" [formControl]="filterControl">
      <button *ngIf="filterControl.value" matSuffix mat-icon-button (click)="filterControl.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

  </div>
  <div [class.disabled]="!dataSrc.data.length" [appDisableInteraction]="!dataSrc.data.length" class="data-table-container">
    <table mat-table [dataSource]="dataSrc" class="data-table mat-elevation-z8" matSort matSortActive="dtMovimentacao">

      <ng-container matColumnDef="blSelecionado">
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="toggleSelecionarTudo()">
            <mat-icon>{{ areAllSelected() ? 'deselect' : 'select_all' }}</mat-icon>
            <span>{{ areAllSelected() ? 'Desselecionar Tudo' : 'Selecionar Tudo' }}</span>
          </button>

          <ng-container *ngIf="itensSelecionados.length > 0">
            <button mat-menu-item *ngIf="verificaPago(false)" (click)="onPagarListaMovimento()">
              <mat-icon>attach_money</mat-icon>
              <span>Pagar</span>
            </button>
            <button mat-menu-item *ngIf="verificaPago()" (click)="onPagarListaMovimento(false)">
              <mat-icon>money_off</mat-icon>
              <span>Cancelar Pagamento</span>
            </button>
            <button mat-menu-item (click)="onCopiarListaMovimento()">
              <mat-icon>content_copy</mat-icon>
              <span>Copiar</span>
            </button>
            <button mat-menu-item (click)="onDeleteListaMovimento()">
              <mat-icon>delete</mat-icon>
              <span>Excluir</span>
            </button>
          </ng-container>

          <button mat-menu-item *ngIf="controleFinancaXMovimento?.noTipoMovimento !== 'Saída' &&
            controleFinancaXMovimento?.noTipoMovimento !== 'Entrada'" (click)="onCopiarCartao()">
            <mat-icon>content_copy</mat-icon>
            <span>Copiar Cartão</span>
          </button>

          <button mat-menu-item *ngIf="controleFinancaXMovimento?.noTipoMovimento !== 'Saída' &&
            controleFinancaXMovimento?.noTipoMovimento !== 'Entrada'" (click)="onImportarCsv()">
            <mat-icon>upload_file</mat-icon>
            <span>Importar CSV</span>
          </button>

          <button mat-menu-item *ngIf="controleFinancaXMovimento?.noTipoMovimento !== 'Saída' &&
            controleFinancaXMovimento?.noTipoMovimento !== 'Entrada'" (click)="onDeleteCartao()">
            <mat-icon>delete</mat-icon>
            <span>Excluir Cartão</span>
          </button>

        </mat-menu>

        <th mat-header-cell *matHeaderCellDef class="bl-selecionado-column">
          <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="editandoLinha" class="ignore-disable">
            <mat-icon>more_vert</mat-icon>
          </button>
        </th>
        <td mat-cell *matCellDef="let item" class="bl-selecionado-column">
          <mat-checkbox class="custom-checkbox" [(ngModel)]="item.blSelecionado" color="primary"
            (change)="onChangeCheckbox(item)" [disabled]="editandoLinha">
          </mat-checkbox>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="noMovimentacao">
        <th mat-header-cell *matHeaderCellDef class="no-movimentacao-column"> Descrição </th>
        <td mat-cell *matCellDef="let controleFinancaMovimentos" class="no-movimentacao-column">
          <ng-container *ngIf="!controleFinancaMovimentos.editing">
            <div class="no-movimentacao-container">
              <span>{{controleFinancaMovimentos.noMovimentacao}}</span>
              <mat-icon *ngIf="controleFinancaMovimentos.idImagem" class="no-movimentacao-imagem"
                (click)="onVisualizarImagem(controleFinancaMovimentos)">image</mat-icon>
            </div>
          </ng-container>
          <ng-container *ngIf="controleFinancaMovimentos.editing">
            <mat-form-field class="field-column">
              <input type="text" matInput minlength="3" maxlength="100"
                [id]="'input-noMovimentacao-' + controleFinancaMovimentos.idControleFinancaMovimento"
                [(ngModel)]="controleFinancaMovimentos.noMovimentacao" />
            </mat-form-field>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef class="no-movimentacao-column" style="font-weight: bold; text-align: right; padding-right: 10px;"> Total </td>
      </ng-container>

      <ng-container matColumnDef="blGeradaCopia">
        <th mat-header-cell *matHeaderCellDef class="copy-status-column"></th>
        <td mat-cell *matCellDef="let controleFinancaMovimentos" class="copy-status-column">
          <button *ngIf="!editandoLinha && !controleFinancaMovimentos.editing" type="button" class="copy-status-icon" tabindex="-1"
            [attr.aria-label]="controleFinancaMovimentos.blGeradaCopia ? 'Copiar movimento novamente' : 'Copiar movimento'"
            (click)="onCopiarMovimento(controleFinancaMovimentos)">
            <mat-icon>content_copy</mat-icon>
            <mat-icon *ngIf="controleFinancaMovimentos.blGeradaCopia" class="copy-status-check">check</mat-icon>
          </button>
          <span *ngIf="editandoLinha || controleFinancaMovimentos.editing" class="copy-status-icon copy-status-icon--somente-leitura">
            <mat-icon>content_copy</mat-icon>
            <mat-icon *ngIf="controleFinancaMovimentos.blGeradaCopia" class="copy-status-check">check</mat-icon>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef class="copy-status-column"></td>
      </ng-container>

      <ng-container matColumnDef="vlMovimentacao">
        <th mat-header-cell *matHeaderCellDef class="vl-movimentacao-column"> Valor </th>
        <td mat-cell *matCellDef="let controleFinancaMovimentos" class="vl-movimentacao-column">
          <ng-container *ngIf="!controleFinancaMovimentos.editing">R$
            {{controleFinancaMovimentos.vlMovimentacao.toFixed(2).toLocaleString('pt-BR').replace('.',
            ',')}}</ng-container>
          <ng-container *ngIf="controleFinancaMovimentos.editing">
            <mat-form-field class="vl-movimentacao-column">
              <input type="number" matInput [(ngModel)]="controleFinancaMovimentos.vlMovimentacao" />
            </mat-form-field>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef class="vl-movimentacao-column" style="font-weight: bold;">
          R$ {{valorTotalSelecionado.toFixed(2).replace('.', ',')}}
        </td>
      </ng-container>

      <ng-container matColumnDef="dtMovimentacao">
        <th mat-header-cell *matHeaderCellDef class="dt-movimentacao-column"> Data </th>
        <td mat-cell *matCellDef="let controleFinancaMovimentos" class="dt-movimentacao-column">
          <ng-container *ngIf="!controleFinancaMovimentos.editing">{{controleFinancaMovimentos.dtMovimentacao |
            date:'dd/MM/yyyy'}}</ng-container>
          <ng-container *ngIf="controleFinancaMovimentos.editing">
            <mat-form-field class="dt-movimentacao-column">
              <input matInput [matDatepicker]="dtMovimentacao" [(ngModel)]="controleFinancaMovimentos.dtMovimentacao">
              <mat-datepicker-toggle matSuffix [for]="dtMovimentacao" tabindex="-1"></mat-datepicker-toggle>
              <mat-datepicker #dtMovimentacao></mat-datepicker>
            </mat-form-field>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="dtVencimento">
        <th mat-header-cell *matHeaderCellDef class="dt-vencimento-column"> Vcto. </th>
        <td mat-cell *matCellDef="let controleFinancaMovimentos" class="dt-vencimento-column">
          <ng-container *ngIf="!controleFinancaMovimentos.editing">{{controleFinancaMovimentos.dtVencimento |
            date:'dd/MM/yyyy'}}</ng-container>
          <ng-container *ngIf="controleFinancaMovimentos.editing">
            <mat-form-field class="dt-vencimento-column">
              <input matInput [matDatepicker]="dtVencimento" [(ngModel)]="controleFinancaMovimentos.dtVencimento">
              <mat-datepicker-toggle matSuffix [for]="dtVencimento" tabindex="-1"></mat-datepicker-toggle>
              <mat-datepicker #dtVencimento></mat-datepicker>
            </mat-form-field>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="buttons">
        <th mat-header-cell *matHeaderCellDef class="buttons-column">
          <button [id]="controleFinancaXMovimento!.noTipoMovimento!" mat-mini-fab (click)="onCreate()" color="primary"
            [disabled]="editandoLinha || itensSelecionados.length > 0" class="ignore-disable">
            <mat-icon>add</mat-icon>
          </button>
        </th>
        <td class="buttons-column" mat-cell *matCellDef="let controleFinancaMovimentos">
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onSalvarLinha(controleFinancaMovimentos, true)">
              <mat-icon>{{controleFinancaMovimentos.blPago ? 'money_off' : 'attach_money'}}</mat-icon>
              <span>{{controleFinancaMovimentos.blPago ? 'Cancelar Pagamento' : 'Pagar'}}</span>
            </button>
            <button mat-menu-item (click)="onCopiarMovimento(controleFinancaMovimentos)">
              <mat-icon>content_copy</mat-icon>
              <span>{{!controleFinancaMovimentos.blGeradaCopia ? 'Copiar' : 'Copiar Novamente' }}</span>
            </button>
            <button *ngIf="!controleFinancaMovimentos.idImagem" mat-menu-item
              (click)="onAnexarImagem(controleFinancaMovimentos)">
              <mat-icon>attach_file</mat-icon>
              <span>Anexar Imagem</span>
            </button>
            <button *ngIf="controleFinancaMovimentos.idImagem" mat-menu-item
              (click)="onVisualizarImagem(controleFinancaMovimentos)">
              <mat-icon>visibility</mat-icon>
              <span>Visualizar Imagem</span>
            </button>
            <button *ngIf="controleFinancaXMovimento?.noTipoMovimento === 'Saída' && listaCartoes.length > 0" mat-menu-item [matMenuTriggerFor]="cartoesMenu">
              <mat-icon>credit_card</mat-icon>
              <span>Definir Cartão</span>
            </button>
            <mat-menu #cartoesMenu="matMenu">
              <button mat-menu-item *ngFor="let cartao of listaCartoes" (click)="onDefinirCartao(controleFinancaMovimentos.idControleFinancaMovimento!, cartao.idControleFinancaXMovimento)">
                {{cartao.noTipoMovimento}}
              </button>
            </mat-menu>
            <button mat-menu-item (click)="onEdit(controleFinancaMovimentos)">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="onDelete(controleFinancaMovimentos)">
              <mat-icon>delete</mat-icon>
              <span>Excluir</span>
            </button>
          </mat-menu>
          <button mat-mini-fab
            [disabled]="!controleFinancaMovimentos.noMovimentacao || controleFinancaMovimentos.noMovimentacao.trim().length < 3 || 
            controleFinancaMovimentos.vlMovimentacao === null || !controleFinancaMovimentos.dtMovimentacao || subscription"
            class="cell-button ignore-disable" color="primary" *ngIf="controleFinancaMovimentos.editing"
            matTooltip="Salvar" (click)="onSalvarLinha(controleFinancaMovimentos)">
            <mat-icon>save</mat-icon>
          </button>
          <button mat-mini-fab class="cell-button" color="warn" *ngIf="controleFinancaMovimentos.editing"
            matTooltip="Cancelar" (click)="onCancelarLinha(controleFinancaMovimentos)">
            <mat-icon>cancel</mat-icon>
          </button>
          <button mat-icon-button class="cell-button ignore-disable" [matMenuTriggerFor]="menu" *ngIf="!editandoLinha"
            [disabled]="itensSelecionados.length > 0">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="dataCols"></tr>
      <tr mat-row *matRowDef="let row; columns: dataCols;"
        [ngClass]="{'bl-pago': row.blPago, 'bl-selecionado': row.blSelecionado }"></tr>
      <tr mat-footer-row *matFooterRowDef="dataCols" [hidden]="itensSelecionados.length === 0" style="background-color: #f5f5f5;"></tr>
    </table>
    <mat-paginator #paginator showFirstLastButtons [length]="dataSrc.data.length" [pageIndex]="0" [pageSize]="50"
      [pageSizeOptions]="[10, 25, 50, 100]" (page)="dataSrc.paginator = paginator">
    </mat-paginator>
  </div>
  <div [hidden]="dataSrc.data.length || subscription">
    <mat-card class="nenhum-registro">
      <p class="mensagem">Nenhum registro encontrado</p>
    
      <div class="registro-actions">
        <div class="action-item">
          <button mat-fab color="primary" (click)="onCreate()" [disabled]="editandoLinha">
            <mat-icon>add</mat-icon>
          </button>
          <span>Novo Registro</span>
        </div>
    
        <ng-container *ngIf="controleFinancaXMovimento?.noTipoMovimento !== 'Saída' &&
                             controleFinancaXMovimento?.noTipoMovimento !== 'Entrada'">
          <div class="action-item">
            <button mat-fab color="primary" (click)="onCopiarCartao()" [disabled]="editandoLinha">
              <mat-icon>content_copy</mat-icon>
            </button>
            <span>Copiar Cartão</span>
          </div>

          <div class="action-item">
            <button mat-fab class="action-importar-csv" (click)="onImportarCsv()" [disabled]="editandoLinha">
              <mat-icon>upload_file</mat-icon>
            </button>
            <span>Importar CSV</span>
          </div>

          <div class="action-item">
            <button mat-fab color="warn" (click)="onDeleteCartao()" [disabled]="editandoLinha">
              <mat-icon>delete</mat-icon>
            </button>
            <span>Excluir Cartão</span>
          </div>
        </ng-container>
      </div>
    </mat-card>

  </div>
</div>

<div class="subscription" *ngIf="subscription">
  <div>
    <mat-spinner></mat-spinner>
    <p>Carregando...</p>
  </div>
</div>
